import React, { forwardRef } from 'react';

import cn from 'classnames';
import * as Ariakit from '@ariakit/react';
import { CaretDown } from '@periodica/ui-kit/icons';

import * as styles from './styles.module.css';

export interface AccordionProps {
  title: string | React.ReactNode;
  content: string | React.ReactNode;
  defaultOpen?: boolean;
  variant?: 'regular' | 'info';
  className?: string;
  style?: React.CSSProperties;
}

export const Accordion = forwardRef<HTMLDivElement, AccordionProps>(function AccordionImpl(
  { title, content, variant = 'regular', className = '', style = {}, defaultOpen = false },
  ref
) {
  return (
    <div
      className={cn([styles.wrapper, variant === 'info' && styles.info, className])}
      ref={ref}
      style={style}
    >
      <Ariakit.DisclosureProvider defaultOpen={defaultOpen}>
        <Ariakit.Disclosure className={styles.button}>
          <span>{title}</span>

          <CaretDown className={cn(styles.icon)} />
        </Ariakit.Disclosure>

        <Ariakit.DisclosureContent className={styles.contentWrapper}>
          <div>
            <div className={styles.content}>{content}</div>
          </div>
        </Ariakit.DisclosureContent>
      </Ariakit.DisclosureProvider>
    </div>
  );
});
